import React, { useEffect, useState } from 'react';
import { Alert, Box, Card, CardContent, Container, Link, Stack, TextField, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import api from '../api';

interface SchoolResult { type: string; title: string; path: string; }

const SchoolSearch: React.FC = () => {
  const [params] = useSearchParams();
  const query = params.get('q') || '';
  const [results, setResults] = useState<SchoolResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!query.trim()) { setResults([]); setError(false); return; }
    setLoading(true);
    setError(false);
    api.get('/school-search', { params: { q: query }, withCredentials: true })
      .then((response) => setResults(response.data?.results || []))
      .catch(() => { setResults([]); setError(true); })
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 7 }, minHeight: '70vh' }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>School Search</Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>Search WAEC and JAMB subjects and learning topics.</Typography>
      <TextField fullWidth value={query} label="Search school content" InputProps={{ readOnly: true }} sx={{ mb: 3 }} />
      {loading ? <Typography color="text.secondary">Searching...</Typography> : error ? <Alert severity="error">School search is temporarily unavailable. Please try again.</Alert> : results.length === 0 ? <Alert severity="info">No school content matched “{query}”.</Alert> : (
        <Stack spacing={2}>
          {results.map((result, index) => <Card key={`${result.path}-${index}`} variant="outlined"><CardContent><Typography variant="caption" color="primary">{result.type}</Typography><Box><Link component={RouterLink} to={result.path} underline="hover" variant="h6">{result.title}</Link></Box></CardContent></Card>)}
        </Stack>
      )}
    </Container>
  );
};

export default SchoolSearch;